import { FC } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import Icon from "@/components/ToastDialogs/Icon";
import Text from "../Text";
import useToasts from "@/hooks/useToasts";
import { Toast } from "@/models/toasts";

export const Box = styled(motion.div)`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 40px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  width: 232px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 17px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  margin-top: 12px;
`;

export const Actions = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 16px;
  margin-top: 32px;
  > button {
    padding: 0;
  }
`;

const IconHolder = styled.div`
  display: flex;
  align-items: center;
`;

const CloseButton = styled.button`
  color: ${({ theme }) => theme.colors.lightGray};
  transition: color ease-out 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: ${({ theme }) => theme.colors.black};
  }
`;

const Headline = styled(Text)`
  margin-left: 16px;
`;

interface Props {
  toast: Toast;
}

const Toasts: FC<Props> = ({ toast }) => {
  const toasts = useToasts();

  const onClose = () => {
    toasts.close(toast.id);
  };

  const renderTitle = () => {
    if (toast.message) {
      return toast.message;
    }

    switch (toast.status) {
      case "success":
        return "Done";
      case "error":
        return "Failed";
      case "loading":
        return "Loading...";
      default:
        return null;
    }
  };

  if (toast.status !== "loading") {
    setTimeout(() => {
      toasts.close(toast.id);
    }, 3000);
  }

  return (
    <Box initial={{ scale: 0.3 }} animate={{ scale: 1 }} exit={{ scale: 0.3 }}>
      <IconHolder>
        <Icon type={toast.status} />
        <Headline $type="caption">{renderTitle()}</Headline>
      </IconHolder>
      {toast.status !== "loading" && (
        <CloseButton onClick={onClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 18L6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CloseButton>
      )}
    </Box>
  );
};

export default Toasts;
